module.exports = __webpack_public_path__ + "img/dummyface.847a66b5.svg";